import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { ReactComponent as RupeesIcon } from "../../image/RupeesIcon.svg";
import {
  Layout,
  Radio,
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Collapse,
  Upload,
  Spin,
  Breadcrumb
} from "antd";
import { useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import PhoneInput from "react-phone-input-2";

import InputField from "../../common/htmlComponents/InputField";
import { t } from "i18next";
import EmailField from "../../common/htmlComponents/EmailField";
import { authUserData } from "../../utils/Helper";
import { Trans } from "react-i18next";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import moment from "moment";
// import NewPermissionPanelStep from "./NewPermissionPanelStep";
import NewPermissionPanelStep from "../../authentication/steps/NewPermissionPanelStep";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const { Option } = Select;

const mockData = Array.from({
  length: 20,
}).map((_, i) => ({
  key: i.toString(),
  title: `content${i + 1}`,
  description: `description of content${i + 1}`,
}));
const initialTargetKeys = mockData
  .filter((item) => Number(item.key) > 10)
  .map((item) => item.key);
const { Panel } = Collapse;
const AddSuperUser = () => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const formRef = useRef();
  const { id } = useParams();

  const EmployeeId = id ? id : null;
  // const hasPermission = authUserData()?.role[0].name;
  const { Panel } = Collapse;

  const Admin = authUserData()?.company_role;

  const [defaultCategory, setDefaultCategory] = useState(null);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [cityDropdownOptions, setCityDropdownOptions] = useState([]);

  const [uploadFile, setUploadFile] = useState("");
  const [uploadFileAadhar, setUploadFileAadhar] = useState("");
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [pincodeList, setPincodeList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [per, setper] = useState([]);

  const [seniorEmployee, setSeniorEmployee] = useState([]);
  const [apiLoading, setapiloading] = useState(false);
  const hasPermission = authUserData()?.role[0].name;

  const [btnLoading, setBtnLoading] = useState(false);

  const [roleName, setRoleName] = useState([]);
  const [mockData, setMockData] = useState([]);

  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const [categoryTree, setCategoryTree] = useState([]);

  const [siteEmployee, setSiteEmployee] = useState([]);
  const [permissionDatas, setPermissionDatas] = useState([]);

  const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    employee_id: "",
    role: [],
    permission: [],
    category_tree: [1],
    senior_employee: null,
  };
  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  const [arrow, setArrow] = useState("Show");
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const colors = ["#094E8F"];

  const [targetKeys, setTargetKeys] = useState(initialTargetKeys);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
  };
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const companyAdmin = authUserData()?.company_role
    ? authUserData()?.company_role
    : null;
  const vendorAdmin = authUserData()?.vendor_role
    ? authUserData()?.vendor_role
    : null;
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  const onScroll = (direction, e) => {
    console.log("direction:", direction);
    console.log("target:", e.target);
  };

  const phoneValidLength = state?.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const getSenior = async (data) => {
    await getRequest("employee/employees-by-company/?no_pagination=True", data)
      .then((response) => {
        setSeniorEmployee(response.data.results.data);
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
        // Handle the error (e.g., show a message to the user)
      });
  };
  const handleSeniorChange = (values) => {
    setState({ ...state, senior_employee: values });
  };
  // const getRoleName = async (data) => {
  //   await getRequest("get-group/", data).then((response) => {
  //     setRoleName(response.data.results.data);
  //   });
  // };
  const getRoleName = async (data) => {
    await getRequest(`get-group/?no_pagination=True`).then((response) => {
      console.log("response 11 ", response);
      // setRoleName(response.data.results.data);
      setRoleName(response.data.data);
    });
  };
  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
        const cementCategory = response.data.data.find(
          (category) => category.name === "Cement"
        );
        if (cementCategory) {
          setDefaultCategory(cementCategory.id);
        }
      }
    );
  };
  const getPermissionByRole = async (id) => {
    let comAdmin = Admin === "Company Admin" ? Admin : null;
    let venAdmin = Admin === "Vendor Admin" ? Admin : null;

    let payload = null;

    if (comAdmin) {
      payload = {
        role_name: comAdmin,
        employee_id: EmployeeId,
        group_ids: id,
      };
    } else {
      payload = {
        role_name: venAdmin,
        employee_id: EmployeeId,
        group_ids: id,
      };
    }

    try {
      const permissionResponse = await patchRequest(
        "list-permission/group-wise-permission/",
        payload
      );

      setTargetKeys(permissionResponse.data.data.map((item) => item.id));

      // setState((prevState) => ({
      //   ...prevState,
      //   role: id,
      //   permission: permissionResponse.data.data.map(
      //     (item) => item.permission_id
      //   ),
      // }));

      setState((prevState) => {
        const updatedPermissions = permissionResponse.data.data
          .filter((item) => item.is_checked === true)
          .map((item) => item.permission_id);

        console.log("Filtered Permissions:", updatedPermissions);

        return {
          ...prevState,
          role: id,
          permission: updatedPermissions,
        };
      });

      setPermissionDatas(permissionResponse.data.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };
  //   const getPermissionByRole = async (id) => {
  //     const permissionResponse = await getRequest(
  //       "create-group-permissions/" + id
  //     );
  //     setTargetKeys(
  //       permissionResponse.data.response.permissions.map((item) => item.id),
  //       // "create-group-permissions/" + id
  //       "list-permission/"
  //     );
  //     // setTargetKeys(
  //     //   permissionResponse.data.response.permissions.map((item) => item.id)
  //     // );
  //     setState({
  //       ...state,
  //       role: id,
  //       permission: permissionResponse.data.response.permissions.map(
  //         (item) => item.id
  //       ),
  //       // permission: permissionResponse.data.response.permissions.map(
  //       //   (item) => item.id
  //       // ),
  //     });
  //   };

  // const getPermission = async () => {
  //   try {
  //     setapiloading(true);
  //     // const permissionArray = await getRequest("list-permission/");

  //     let permissionArray;
  //     // );
  //     if (CompanyId) {
  //       permissionArray = await getRequest(
  //         `list-permission/?group_name=${companyAdmin}`
  //       );
  //     } else {
  //       permissionArray = await getRequest(
  //         `list-permission/?group_name=${vendorAdmin}`
  //       );
  //     }

  //     if (permissionArray.data.success) {
  //       if (permissionArray.data.data) {
  //         setPermissionDatas(permissionArray.data.data);
  //         const formattedData = permissionArray.data.data.map((item) => ({
  //           key: item.id,
  //           // title: item.name,
  //           title: item.name.toLowerCase(),
  //         }));
  //         setMockData(formattedData);
  //       }
  //       setapiloading(false);
  //     }
  //     setapiloading(false);
  //   } catch (error) {
  //     setapiloading(false);
  //     ErrorNotificationMsg("Error fetching permissions");
  //   }
  // };

  const getPermission = async () => {
    try {
      setapiloading(true);
      // const permissionArray = await getRequest("list-permission/");

      let permissionArray;
      // );

      permissionArray = await getRequest(
        `create-group-permissions/get-group-permission-by-user/`
      );
      console.log("permissionArray 22 ", permissionArray);
      if (permissionArray.data.success) {
        if (permissionArray.data.response) {
          setPermissionDatas(permissionArray.data.data);
          //     const formattedData = permissionArray.data.data.map((item) => ({
          //       key: item.id,
          //       // title: item.name,
          //       title: item.name.toLowerCase(),
          //     }));
          //     setMockData(formattedData);
        }
        setapiloading(false);
      }
      setapiloading(false);
    } catch (error) {
      setapiloading(false);
      ErrorNotificationMsg("Error fetching permissions");
    }
  };

  console.log("permissionDatas 010 ", permissionDatas);

  const groupedPermissions = permissionDatas?.reduce((groups, permission) => {
    const { model_name } = permission;
    if (!groups[model_name]) {
      groups[model_name] = [];
    }
    groups[model_name].push(permission);
    return groups;
  }, {});

  console.log("groupedPermissions 145 ", groupedPermissions);

  useEffect(() => {
    const employeeGetById = async () => {
      try {
        const apiResponse = await getRequest(`employee/${EmployeeId}/`);
        console.log("apiResponse 210 ", apiResponse);

        if (apiResponse.data.success) {
          const {
            id,
            senior_employee,
            created_by,
            updated_by,
            ...filteredResponse
          } = apiResponse.data.data;
          const formattedData = apiResponse.data.data.permission.map(
            (item) => ({
              key: item.id,
              title: item.permission,
            })
          );

          apiResponse.data.data.groups.map((group) =>
            console.log("group", group)
          );

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            employee_id: apiResponse.data.data.employe_id,
            first_name: apiResponse.data.data.first_name,
            last_name: apiResponse.data.data.last_name,
            email: apiResponse.data.data.email,
            phone: String(apiResponse.data.data.phone),
            role: apiResponse.data.data.groups.map((group) => group.role),
            senior_employee: apiResponse.data.data.senior_employee,
          });
          const roles = apiResponse.data.data.groups.map((group) => group.role);
          console.log("Roles:", roles);
          getPermissionByRole(roles);

          setState({
            ...filteredResponse,
            phone: String(apiResponse.data.data.phone),
          });

          // setFileLink(apiResponse.data.data.upload_pancard_doc);
          // try {
          //   filename = apiResponse.data.data.upload_pancard_doc.split("/").pop();
          //   setFileName(filename);
          // } catch (e) {
          //   filename = "";
          //   setFileName(null);
          // }
          // try {
          //   filenameaddhar = apiResponse.data.data.upload_aadhar_doc.split("/").pop();
          //   setFileNameadhar(filenameaddhar);
          // } catch (e) {
          //   filenameaddhar = "";
          //   setFileNameadhar(null);
          // }
          const url = apiResponse.data.data.profile_photo;
          setIdentifyProfileUrl(apiResponse.data.data.profile_photo);
          if (url !== null) {
            setFileList([
              {
                // uid: '-1',
                // name: 'image.png',
                // status: 'done',
                url: url,
              },
            ]);
          }
        }
      } catch (error) {
        ErrorNotificationMsg(t("error_in_list_employee"));
      }
    };
    if (EmployeeId !== null) {
      employeeGetById();
    }
    //getCityByState();
    // getPermission();
    // getState();
    getRoleName();
    getSenior();
    // getPermission();
    //getCategoryTree();
    if (hasPermission !== "Super Admin" && hasPermission !== "Vendor Admin") {
      getSite();
      // getCurrency();
    }
  }, [EmployeeId, t]);
  const getSite = async (data) => {
    await getRequest("employee/site-by-company/?no_pagination=True", data).then(
      (response) => {
        setSiteEmployee(response.data.results.data);
      }
    );
  };

  const handleRoleSelectChange = (value) => {
    console.log("value 8", value, "state", state);
    // setState((prevState) => ({
    //   ...prevState
    // }));
    if (value.length > 0) {
      getPermissionByRole(value);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  // useEffect(() => {
  //   getPermission()
  // }, [state.role])

  const handleSubmit = async () => {
    const payload = {
      employe_id: state.employee_id,
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      phone: state.phone,
      role: state.role,
      permission: state.permission,
      // category_tree: state.category_tree,
      senior_employee: state.senior_employee,
    };

    // const assignSiteEmployeeIds = state.assign_site_employee
    // .filter(site => site.id !== null && site.id !== undefined) // Filter out any sites with null or undefined IDs
    // .map(site => site.id); // Map to just the IDs

    const payload2 = {
      employe_id: state.employe_id,
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      phone: state.phone,
      role: state.role,
      permission: state.permission,
      senior_employee: state.senior_employee,
    };

    try {
      setBtnLoading(true);
      let response;

      const formData = new FormData();
      formData.append("profile_photo", uploadFileProfilePic);
      // formData.append("upload_aadhar_doc", uploadFileAadhar);
      // formData.append("upload_pancard_doc", uploadFile);
      if (EmployeeId === null) {
        formData.append("form_data", JSON.stringify(payload));
      } else {
        formData.append("form_data", JSON.stringify(payload2));
      }
      // try {
      //   setBtnLoading(true);
      //   let response;
      if (EmployeeId === null) {
        response = await postRequest("employee/", formData);
      } else {
        response = await patchRequest(`employee/${EmployeeId}/`, formData);
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          EmployeeId === null
            ? response.data.message
            : t("employee_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        updateSubscriptionStatus();
        navigate("/superuser");
      }
    } catch (error) {
      if (EmployeeId === null) {
        ErrorNotificationMsg(
          // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
          t("error_in_adding_employee")
        );
      }
      if (EmployeeId !== null && !error?.message) {
        ErrorNotificationMsg(
          // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
          t("error_in_updating_employee")
        );
      }

      setBtnLoading(false);
    }
  };

  // const handleSiteChange = (values) => {
  //   console.log('values 8', values, 'state 8', state);
  //   setState({ ...state, assign_site_employee: values });
  // };
  // console.log('siteEmployee', siteEmployee);
  // const handleSiteChange = (selectedSiteIds) => {
  //     console.log('Selected Site IDs:', selectedSiteIds, 'Current State:', state);
  //
  //     // Map selected IDs to the full site objects
  //     const selectedSites = selectedSiteIds.map(id => {
  //         const site = siteEmployee.find(site => site.site_id === id);
  //         return site ? { id: site.site_id, site_name: site.site_name } : null;
  //     }).filter(site => site !== null); // Remove any null values
  //
  //     console.log('Selected Sites:', selectedSites);
  //
  //     setState({ ...state, assign_site_employee: selectedSites });
  // };

  const handleChangePr = (name, value) => {
    setState({ ...state, [name]: value });
  };

  // const getUniqueObjectsByModelName = (permissionDatas) => {
  //   console.log('permissionDatas 11 ', permissionDatas);
  //   const uniqueObjects = [];
  //   const modelNames = new Set();

  //   permissionDatas.forEach(permission => {
  //     if (!modelNames.has(permission.model)) {
  //       console.log('per ', permission);
  //       modelNames.add(permission.model);
  //       uniqueObjects.push(permission);
  //     }
  //   });
  //   console.log('unique ', uniqueObjects);
  //   return uniqueObjects;
  // };
  // const uniquePermissions = useMemo(() => getUniqueObjectsByModelName(permissionDatas), [permissionDatas]);

  // console.log('uniquePermissions ', uniquePermissions);

  // setper(permissionDatas);

  return (
    <>
     <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
       {EmployeeId ? (
                      <h3> Edit User </h3>
                    ) : (
                      <h3> Add User </h3>
                    )}
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
       {EmployeeId ? (
                      <Breadcrumb.Item>Edit User </Breadcrumb.Item>
                    ) : (
                      <Breadcrumb.Item>Add User</Breadcrumb.Item>
                    )}
                  
                </Breadcrumb>
                </div>
             
              
            </div>
          </div>
      <section className="grid-sec FormSection Container">
        
          <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} className="stepscontentwrap">
           
               
                
                  <div className="stepsContent">
                    <div className="formwrapper">
                      <Spin spinning={apiLoading}>
                      <div className="formrowsection">
                        <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                          <Panel header="Personal Info" key="1">
                            <Row gutter={16}>
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                              >
                                <InputField
                                  name="first_name"
                                  label={t("label_firstName")}
                                  placeholder={t("pl_firstName")}
                                  rules={t("val_name")}
                                  value={state.first_name}
                                  pattern={"^[a-zA-Z ]+$"}
                                  handleInputChange={handleInputChange}
                                  max={30}
                                />
                              </Col>

                              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                                <Form.Item>
                                  {" "}
                                  <InputField
                                    name="last_name"
                                    label={t("label_lastName")}
                                    placeholder={t("pl_lastName")}
                                    pattern={"^[a-zA-Z ]+$"}
                                    rules={t("val_name")}
                                    value={state.last_name}
                                    handleInputChange={handleInputChange}
                                    max={30}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                                <Form.Item>
                                  {" "}
                                  <EmailField
                                    name="email"
                                    label={t("label_email")}
                                    placeholder="Enter email"
                                    rules={t("val_email")}
                                    value={state.email}
                                    handleInputChange={handleInputChange}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                                <Form.Item
                                  name="phone"
                                  label={t("Contact Number")}
                                  placeholder={t("pl_mobileNumber")}
                                  rules={[
                                    {
                                      required: true,
                                      validator: validatePhoneNumber,
                                      message: (
                                        <Trans> {t("val_mobileNumber")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <div className="phonefield">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      value={state.phone}
                                      onChange={(phone) =>
                                        setState({ ...state, phone: phone })
                                      }
                                    />
                                  </div>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                                <Form.Item>
                                  <InputField
                                    name="employee_id"
                                    label={t("label_employeeId")}
                                    placeholder="Enter Employee Id"
                                    value={state.employee_id}
                                    handleInputChange={handleInputChange}
                                    max={50}
                                  />
                                </Form.Item>
                              </Col>

                              {seniorEmployee && seniorEmployee.length > 0 && (
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={6}
                                  xl={6}
                                  className="TextFeild gutter-row"
                                >
                                  <Form.Item
                                    name="senior_employee"
                                    label="Line Manager/ Workflow Approver"
                                    rules={[
                                      {
                                        required:
                                          !!seniorEmployee &&
                                          seniorEmployee.length > 1,
                                        message: "Please enter senior",
                                      },
                                    ]}
                                  >
                                    {seniorEmployee &&
                                      seniorEmployee.length > 0 && (
                                        <Select
                                          className="cust-selectBox"
                                          showArrow
                                          showSearch
                                          allowClear
                                          placeholder="Select line manager"
                                          optionFilterProp="children"
                                          onChange={handleSeniorChange}
                                          value={state.senior_employee}
                                        >
                                          {seniorEmployee &&
                                            seniorEmployee.length > 0 &&
                                            seniorEmployee.map((item) => {
                                              if (
                                                String(EmployeeId) !==
                                                String(item.employee_id)
                                              ) {
                                                return (
                                                  <Select.Option
                                                    key={item.id}
                                                    value={item.id}
                                                  >
                                                    {`${item.first_name} ${item.last_name}`}
                                                  </Select.Option>
                                                );
                                              } else {
                                                return null; // Don't render anything if EmployeeId matches item.id
                                              }
                                            })}
                                        </Select>
                                      )}
                                  </Form.Item>
                                </Col>
                              )}

                              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                                <Form.Item
                                  name="role"
                                  label={t("label_role")}
                                  value={state.role}
                                >
                                  <Select
                                    showArrow
                                    mode="multiple"
                                    showSearch
                                    allowClear
                                    placeholder={t("label_role")}
                                    optionFilterProp="children"
                                    value={state.role}
                                    onChange={(value) =>
                                      handleRoleSelectChange(value)
                                    }
                                  >
                                    {roleName.map((item) => (
                                      <Option key={item.id} value={item.id}>
                                        {item.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                        <div className="sectiontitle"><span>Additional Permission</span></div>

                        <div className="steppermission">
                          {groupedPermissions &&
                            Object.entries(groupedPermissions).map(
                              ([modelName, permissions], index) => {
                                //console.log('permissions 20 ', permissions)
                                return (
                                  <NewPermissionPanelStep
                                    key={index}
                                    state={state}
                                    modelName={modelName}
                                    permissions={permissions}
                                    setState={setState}
                                    index={index}
                                  />
                                );
                              }
                            )}
                        </div>
                      </div>
                      </Spin>
                    </div>
                  </div>
                  <div className="stepsFooter">
                    <Button
                      cursor="pointer"
                      type="secondary"
                      className="primary"
                      onClick={() => navigate("/superuser")}
                    >
                      Cancel
                    </Button>
                    <Button
                      cursor="pointer"
                      type="primary"
                      className="primary"
                      htmlType="submit"
                      label={t("save")}
                      loading={btnLoading}
                    >
                      Save
                    </Button>
                  </div>

            
          </Form>
      
      </section>
    </>
  );
};

export default AddSuperUser;
